import { P3 } from '@repo/ui/components/Typography';

import { NoNotificationsWrapper } from './styles';

const NoNotifications = (): React.ReactElement => {
  return (
    <NoNotificationsWrapper>
      <P3>You don't have notifications</P3>
    </NoNotificationsWrapper>
  );
};

export default NoNotifications;
